<template>
  <div class="content">
    <h1>FirestoreCRUD</h1>
    <div>
      <button @click="createProduct()">데이터 생성</button>
      <button @click="updateProduct()">데이터 수정</button>
      <button @click="deleteProduct()">데이터 삭제</button>
    </div>
    <table>
      <thead>
      <th>idx</th>
      <th>name</th>
      <th>address</th>
      <th>lat</th>
      <th>lng</th>
      <th>phone</th>
      <th>note</th>
      <th>isComplete</th>
      <th>create at</th>
      </thead>
      <tbody>
      <tr v-for="(product, idx) in products" :key="idx">
        <td>{{ idx+1 }}</td>
        <td>{{ product.name }}</td>
        <td>{{ product.address }}</td>
        <td>{{ product.lat }}</td>
        <td>{{ product.lng }}</td>
        <td>{{ product.phone }}</td>
        <td>{{ product.note }}</td>
        <td>{{ product.isComplete }}</td>
        <td v-if="product.createdAt != null">{{ product.createdAt.toDate(), 'YYYY-MM-DD HH:mm:ss' | dateFormat }}</td>
      </tr>
      </tbody>
    </table>
    <div>
      <vue-daum-map
        :appKey="appKey"
        :center.sync="center"
        :level.sync="level"
        :mapTypeId="mapTypeId"
        :libraries="libraries"
        @load="onLoad"
        style="width:500px;height:400px;">
      </vue-daum-map>
    </div>
    {{ a }}
  </div>
</template>

<script>
  import { db, firestore } from '@/firebase'
  import VueDaumMap from 'vue-daum-map'

  export default {
    name: 'FirestoreCRUD',
    components: {
      VueDaumMap
    },
    data () {
      return {
        appKey: this.$config.kakao.appKey, // 테스트용 appkey
        center: {lat: 33.450701, lng: 126.570667}, // 지도의 중심 좌표
        level: 3, // 지도의 레벨(확대, 축소 정도),
        mapTypeId: VueDaumMap.MapTypeId.NORMAL, // 맵 타입
        libraries: [], // 추가로 불러올 라이브러리
        map: null // 지도 객체. 지도가 로드되면 할당됨.
      }
    },
    firestore () {
      return {
        locations: db.collection('locations').orderBy('createdAt'),
        products: db.collection('products').orderBy('createdAt')
      }
    },
    methods: {
      onLoad (map) {
          console.log('onLoad Map')
          this.map = map
      },
      createProduct () {
        if (this.products.length >= 20) {
          return alert('과금된다 그만해라')
        }
        const data = {
          name: 'tanos',
          address: '서울시 관악구 관악로 12-1524',
          lat: '35.1532534',
          lng: '126.2535124',
          phone: '010-1234-1234',
          note: '2시에 집에 들어온다고 함',
          isComplete: false,
          createdAt: firestore.FieldValue.serverTimestamp()
        }
        db.collection('products').add(data).then(ref => {
          console.log('id :', ref.id)
        })
      },
      updateProduct () {
        if (this.products.length > 0) {
          const idx = Math.floor(Math.random() * (this.products.length - 1))
          db.collection('products').doc(this.products[idx]['.key']).update({
            note: '김치 옆집꺼까지 배달 완료',
            isComplete: true
          })
        } else {
          alert('데이터가 없어')
        }
      },
      deleteProduct () {
        if (this.products.length > 0) {
          db.collection('products').doc(this.products[0]['.key']).delete()
        } else {
          alert('데이터가 없어')
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .content {
    padding: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FirestoreCRUD.vue